"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setGlobalLanguage = exports.getGlobalLanguage = exports.onGlobalLanguageChanged = exports.getI18nProvider = exports.translate = exports.i18nProvider = void 0;
const helpers_1 = require("../helpers");
const enums_1 = require("../structs/enums");
const utils_1 = require("../utils");
exports.i18nProvider = 'fluid-i18n-provider';
/**
 * Given a set of translations, an identifier (keyof type T) and a language,
 * returns the translations at that identifier in type U (may be object, not
 * always a straight string)
 * @param translations
 * @param identifier
 * @param language
 */
function translate(translations, identifier, language = enums_1.FluidLanguage.ENGLISH) {
    const path = String(`${language}.${identifier === null || identifier === void 0 ? void 0 : identifier.toString()}`);
    return (0, helpers_1.getAtPath)(translations, path);
}
exports.translate = translate;
/**
 * Search the DOM for the uppermost i18nProvider
 */
const getI18nProvider = () => (0, helpers_1.getRootElement)(exports.i18nProvider);
exports.getI18nProvider = getI18nProvider;
/**
 * Subscribes to changes to the language attribute of the i18n provider.
 * @param callback
 */
function onGlobalLanguageChanged(callback) {
    const provider = (0, exports.getI18nProvider)();
    if (provider) {
        (0, helpers_1.listenForAttributeChange)(provider, 'language', callback);
    }
    else {
        (0, utils_1.CORE_WARNING)('Could not find an instance of i18n Provider to listen to for language change.');
    }
}
exports.onGlobalLanguageChanged = onGlobalLanguageChanged;
/**
 * Returns the current language set on the i18n provider, or English if one can't be found.
 */
function getGlobalLanguage() {
    const provider = (0, exports.getI18nProvider)();
    if (provider) {
        return provider.language;
    }
    else {
        (0, utils_1.CORE_WARNING)('Could not find an instance of i18n Provider to get language - setting English as default.');
        return enums_1.FluidLanguage.ENGLISH;
    }
}
exports.getGlobalLanguage = getGlobalLanguage;
/**
 * Sets the given language as the global language ont he i18n provider, if one is available.
 * @param language
 */
function setGlobalLanguage(language) {
    const provider = (0, exports.getI18nProvider)();
    if (provider) {
        provider.language = language;
    }
    else {
        (0, utils_1.CORE_WARNING)('Could not find an instance of i18n Provider to set language.');
    }
}
exports.setGlobalLanguage = setGlobalLanguage;
